export { default } from './SubTitle';